let juno = null

function getJunoCheckout (publicToken, productionMode) {
  if (!juno) {
    juno = new DirectCheckout(publicToken, productionMode);
  }
  return juno;
}

export function createCardHash (args) {
  const checkout = getJunoCheckout(args.publicToken, !args.sandbox);

  const cardData = {
    cardNumber: (args.number + ''),
    holderName: (args.name + ''),
    securityCode: (args.cvc + ''),
    expirationMonth: (args.expirationMonth + ''),
    expirationYear: ( 4 === args.expirationYear.length ? args.expirationYear : `20${args.expirationYear}` ),
  };

  if (args.sandbox) {
    console.log('[juno] generating hash with data:', cardData);
  }

  function generateHash (resolve, reject) {
    var error = null;

    if (cardData.holderName.length == 0) {
      error = 'Nome Inválido';
    }
    else if (!checkout.isValidCardNumber(cardData.cardNumber)) {
      error = 'Número do Cartão Inválido';
    }
    else if (!checkout.isValidExpireDate(cardData.expirationMonth, cardData.expirationYear)) {
      error = 'Data de Validade Incorreta';
    }
    else if (!checkout.isValidSecurityCode(cardData.cardNumber, cardData.securityCode)) {
      error = 'Código de Segurança Inválido';
    }

    if (error != null) {
      reject(error);
      return;
    } else {
      checkout.getCardHash(cardData, onSuccess, onError);

      function onSuccess (cardHash) {
        if (args.sandbox) {
          console.log('[juno] hash gerado:', cardHash);
        }
        resolve(cardHash);
      }

      function onError (error) {
        if (args.sandbox) {
          console.log('[juno] erro ao gerar hash:', error);
        }
        reject('Cartão Inválido. Confira os dados novamente.');
      }
    }
  }

  return new Promise(generateHash);
}
